import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Instagram subscriber access is no longer offered. Any old link, bookmark or
 * bio URL lands on the membership page instead of a dead end.
 */
export const Route = createFileRoute("/instagram-access")({
  beforeLoad: () => {
    throw redirect({ to: "/membership" });
  },
  component: () => null,
});
